import React, { useEffect, useState } from "react";

// STYLES
import * as Style from "./LayoutStyle";

// LIBRARIES

// MISC
import { IProps } from "./LayoutModel";

// REDUX

// COMPONENTS
import Header from "components/Header/Header";
import SideMenu from "components/SideMenu/SideMenu";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { isSideMenuVisible, toggleIsSideMenuVisible } from "slices/uiSlice";

const Layout = (props: IProps) => {

  // PROPS
  const { children } = props;

  // CONSTANTS USING LIBRARIES
  const isSideMenuVisibleData = useAppSelector(isSideMenuVisible)
  const dispatch = useAppDispatch();

  // CONSTANTS USING HOOKS
  const [screenWidth, setScreenWidth] = useState(0);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    handleResize(); // Apelați funcția handleResize inițial pentru a seta valoarea inițială corectă

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.LayoutContainer>
      {isSideMenuVisibleData && <Style.SideMenuUnderLayer onClick={() => dispatch(toggleIsSideMenuVisible(false))} />}
      {(screenWidth > 860 || isSideMenuVisibleData) &&

        <SideMenu />

      }
      <Style.RightSideWrapper>

        <Header />
        {children}
      </Style.RightSideWrapper>
    </Style.LayoutContainer>
  );
};

export default Layout;
